import { ArticleHeading1, ArticleParagraph1, LinkButton } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { applicationFormUrl } from '../../constants/urls';
import { NBSP } from '../../constants/symbols';

import styles from './styles.css';

export const HeroMobile: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ArticleHeading1 as="h1">Найти хорошего риелтора непросто. Мы{NBSP}поможем!</ArticleHeading1>
        </div>
        <div className={styles['text']}>
          <ArticleParagraph1>
            Риелтор поможет с подготовкой или проверкой документов, обоснует цену, организует весь процесс — от
            просмотров до подписания договора.
          </ArticleParagraph1>
        </div>
        <LinkButton href={applicationFormUrl} size="L" fullWidth>
          Подобрать риелтора
        </LinkButton>
      </Wrapper>
    </div>
  );
};

HeroMobile.displayName = 'HeroMobile';
